import React from 'react';
import { Col, Form, FormFeedback, FormGroup, FormText, Input, Label} from 'reactstrap';
import Select from 'react-select';
import { PlaceHolderOption } from '../../constant';

export const FormRol = (props) => {
    
    const {
        name, ids_views, handleInputChange, handleSelectValues, validationsRole, methodAction, button, listViews
    } = props;

    const {
        name_valid,
        views_valid
    } = validationsRole;


    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            borderRadius: '12px',
            borderColor: state.isFocused
                ? '#46AFE5'
                : '#dbe4f0',
            boxShadow: state.isFocused
                ? '0 0 0 3px rgba(70,175,229,.15)'
                : 'none',
                fontSize: '12px',
            transition: 'all .2s ease',
            '&:hover': {
                borderColor: '#46AFE5'
            }
            
        }),

        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#46AFE5'
                : state.isFocused
                    ? '#eef7fd'
                    : '#fff',
            color: state.isSelected ? '#fff' : '#334155',
            cursor: 'pointer'
        }),

        placeholder: (provided) => ({
            ...provided,
            color: '#94a3b8'
        }),

        menuPortal: (base) => ({
            ...base,
            zIndex: 999999
            }),

            menu: (provided) => ({
                ...provided,
                zIndex: 999999,
                position: 'absolute'
        }),

    };
    return (
        <Form className='form them-form' role="form" onSubmit={methodAction}> 
            <div className="precodedCard">
                <Col sm="12" md="12" lg="12">
                    

                    <FormGroup>
                        <Label style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }} >
                            Rol <span style={{ color: "#46AFE5" }}> *</span>
                        </Label>

                        <Input
                            type="text"
                            name="name"
                            onChange={handleInputChange}
                            value={name}
                            autoComplete="off"
                            invalid={name_valid}
                            placeholder="Ej. Transporte refrigerado"
                            style={{
                                borderRadius: "14px",
                                minHeight: "40px",
                                border: "1px solid #dbe4f0",
                                paddingLeft: "15px",
                                fontSize: "14px",
                                boxShadow: "none"
                            }}
                        />

                        <FormFeedback>El nombre debe contener más de 3 catacteres</FormFeedback>

                    </FormGroup>
                </Col>                    
            
                <Col sm="12" md="12" lg="12">
                    <FormGroup>
                        <Label className='col-form-label'>Vistas <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Select
                            classNamePrefix='select'
                            name="ids_views"
                            value={ids_views}
                            options={listViews}
                            onChange={(e) => handleSelectValues(e, 'ids_views')}
                            placeholder={PlaceHolderOption}
                            isMulti
                            valid
                            theme={
                                (theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#898989'
                                    }
                                })
                            }

                                styles={customSelectStyles}

                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                        <FormText color='danger' hidden={!views_valid}>Debes seleccionar almenos una opción</FormText>
                    </FormGroup>
                </Col>

            </div>

        </Form>
    )

}
